
import { CtaSection as GenericCtaSection } from "@/components/ui/cta-section";

export const CtaSection = () => {
  return (
    <GenericCtaSection
      title="Ready to establish a solid security foundation?"
      description="Get started with a consultation to discuss how well-crafted policies and procedures can transform your security posture."
      buttonText="Schedule a Consultation"
      buttonVariant="cta"
      bgColor="gradient"
      textColor="white"
      useContactModal={true}
      modalTitle="Policy & Procedures Development Consultation"
      modalDescription="Let's discuss how we can help create effective cybersecurity policies and procedures for your organization. Fill out the form below and our experts will contact you to schedule a consultation."
      modalFormId="dfa977cc-c726-4029-89d1-d8f757482a67"
      additionalFields={{ 
        lead_source: "Website",
        lead_interest: "Policy & Procedures Development",
        service_interest: "Security Documentation"
      }}
    />
  );
};
